module.exports = __webpack_public_path__ + "static/media/13.0534ac64.png";